// Importamos Zustand para manejar el estado global de consentimiento de cookies
import { create } from "zustand";

// Configuración por defecto de las cookies
// Define el estado inicial de los diferentes tipos de consentimiento
const defaultConsent = {
  functional: true, // Cookies funcionales - Siempre activas por ser necesarias
  multimedia: false, // Cookies para contenido multimedia (videos, etc.)
  analytics: false, // Cookies de análisis (Google Analytics, etc.)
};

// Creación del store para manejar el consentimiento de cookies
export const useConsentStore = create((set) => ({
  // Estado inicial del consentimiento
  consent: null,

  // Función para establecer consentimientos específicos
  setConsent: (consent) => {
    // Asegura que las cookies funcionales siempre estén activas
    const full = { ...consent, functional: true };
    // Actualiza el estado en Zustand
    set({ consent: full });
    // Guarda las preferencias en localStorage para persistencia
    localStorage.setItem("cookieConsent", JSON.stringify(full));
  },

  // Función para rechazar todas las cookies opcionales
  rejectAll: () => {
    const rejected = {
      functional: true, // Mantiene las funcionales activas
      multimedia: false, // Desactiva multimedia
      analytics: false, // Desactiva analytics
    };
    set({ consent: rejected });
    localStorage.setItem("cookieConsent", JSON.stringify(rejected));
  },

  // Función para aceptar todas las cookies
  acceptAll: () => {
    const accepted = {
      functional: true, // Cookies funcionales
      multimedia: true, // Acepta multimedia
      analytics: true, // Acepta analytics
    };
    set({ consent: accepted });
    localStorage.setItem("cookieConsent", JSON.stringify(accepted));
  },
}));
